export default __webpack_public_path__ + "static/2021PCS_logo-sm-a3acaa5d9cd401d5214d65a8e74ef861.png";